import { all } from 'redux-saga/effects';

import execCommentSaga from './execCommentSaga';
import execConfirmSaga from './execConfirmSaga';
import execDisputeSaga from './execDisputeSaga';
import execReportSaga from './execReportSaga';
import execRefuseSaga from './execRefuseSaga';
import execRemakeSaga from './execRemakeSaga';
import execAnswerConfirmSaga from './execAnswerConfirmSaga';
import execCancelByTaskOwnerSaga from './execCancelByTaskOwnerSaga';
import execAddMaterialsSaga from './execAddMaterialsSaga';
import execDeleteMaterialsSaga from './execDeleteMaterialsSaga';

export default function* createSaga(reducerName) {
  yield all([
    ...execCommentSaga(reducerName),
    ...execConfirmSaga(reducerName),
    ...execDisputeSaga(reducerName),
    ...execReportSaga(reducerName),
    ...execRefuseSaga(reducerName),
    ...execRemakeSaga(reducerName),
    ...execAnswerConfirmSaga(reducerName),
    ...execCancelByTaskOwnerSaga(reducerName),
    ...execAddMaterialsSaga(reducerName),
    ...execDeleteMaterialsSaga(reducerName)
  ]);
}



// WEBPACK FOOTER //
// ./src/mt-react-common/modules/tasks/reducers/dynamic/taskExecExecutorForms/saga/index.js